/*
 * NOTE: This function is a duplicate of the one in sharedImageViewer. If this
 * function changes the one in shared-image-viewer should change as well.
 */

import { i18n } from '@fs/zion-locale'
import { formatWithRules, joinDates } from './dateUtils'

export const dateFormats = {
  formatted: 'formatted',
  formattedFullWithTime: 'formattedFullWithTime',
  formattedCompactWithTime: 'formattedCompactWithTime',
  formattedCompactWithHourMinute: 'formattedCompactWithHourMinute',
  formattedMinimalWithTime: 'formattedMinimalWithTime',
}

export default function getFormattedDate(fromTimestamp = null, toTimestamp = null, dateFormat = dateFormats.formatted) {
  // check if dates are nullish instead of falsy so timestamp 0 can be used
  const fromISOString = fromTimestamp !== null ? new Date(fromTimestamp).toISOString() : null
  const toISOString = toTimestamp !== null ? new Date(toTimestamp).toISOString() : null
  const fromDate = fromTimestamp ? new Date(fromTimestamp) : null
  const toDate = toTimestamp ? new Date(toTimestamp) : null
  const locale = i18n.language

  if (dateFormat === 'formatted') return formatWithRules({ fromISOString, toISOString, locale })

  const formatMap = {
    formattedFullWithTime: 'FULL_WITH_TIME',
    formattedCompactWithTime: 'COMPACT_WITH_TIME',
    formattedCompactWithHourMinute: 'COMPACT_WITH_HOUR_MINUTE',
    formattedMinimalWithTime: 'MINIMAL_WITH_TIME',
  }
  const format = formatMap?.[dateFormat]
  if (!format) throw new Error(`The date format ${dateFormat} does not exist`)

  return joinDates({ fromDate, toDate, format, locale })
}
